import type {ReactElement} from 'react';
import React from 'react';
import {Text, TextSize} from '@Components/text';
import styles from './text-with-info.module.scss';

interface TextWithInfoProps {
  className?: string;
  text: string;
  subText: string;

  onClick(): void;
}

export function TextWithInfo({className = '', ...props}: TextWithInfoProps): ReactElement<any> | null {
  return (
    <div
      onClick={(): void => {
        props.onClick();
      }}
      className={`flex-v-row spacing-p-r-2 spacing-p-l-2 spacing-p-b-1 spacing-p-t-1 radius-4 ${className} ${styles.container}`}
    >
      <Text val={props.text} size={TextSize.XSMALL} bold />
      <Text val={props.subText} size={TextSize.XXSMALL} className="content-sub-text" />
    </div>
  );
}
